export default __webpack_public_path__ + "static/media/confused.3241caad.svg";